import { MapRouteName } from "src/helpers/mapConstants";
import { mapColors } from "src/helpers/uiConstants";

export default function RouteLineExample({
  scenario,
}: {
  scenario: MapRouteName;
}) {
  return (
    <div
      className="min-w-[10px] h-[30px] rounded-md"
      style={{
        backgroundColor: mapColors[scenario as MapRouteName],
      }}
    ></div>
  );
}
